import React, {Component} from 'react';
import GetCapabilities from "../../../../includes/GetCapabilities";
import { connect } from "react-redux";
import {endpointFieldChange} from "../../../../store/actions/endpoints";

class Privacy extends Component {

	constructor(props) {
		super(props);

		this.state = {
			capabilities:        [
				{
					name:  'Everyone is allowed',
					value: 'all'
				},
			],
		};
	}

	componentDidMount() {
		this.setState( GetCapabilities( this.state.capabilities ) );
	}

	render() {

		const { id, capability, endpointFieldChange, sectionVisibility, premium } = this.props;

		return (
			<div id="poststuff" className="privacy-box">
				<div id="slugdiv" className="postbox ">
					<h2 className="hndle ui-sortable-handle" onClick={ e => endpointFieldChange( !sectionVisibility, id, 'privacySection' ) }><span>Define the privacy</span></h2>
					<div className="inside" style={{display: sectionVisibility ? 'block' : 'none'}}>
						<p>Is this endpoint protected? If so, choose who can access it.</p>
						<p>Bear in mind that you will need some third-party plugin for managing the authentication process.</p>
						<select value={capability} onChange={ e => (premium || e.target.value === 'all') && endpointFieldChange( e.target.value, id, 'capability' ) } >
							{this.state.capabilities.map((m, index) => <option key={index} disabled={(premium || m.value === 'all') ? '' : 'disabled'} value={m.value}>{m.name} {!premium &&  m.value !== 'all' ? '(PRO)' : ''}</option>)}
						</select>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = ( state, props ) => ({
	id: props.id,
	capability: state.settings.endpoints[props.id].capability,
	sectionVisibility: state.settings.endpoints[props.id].privacySection,
  premium: state.premium
});

const mapDispatchToProps = dispatch => ({
	endpointFieldChange: ( value, endpointId, field ) => dispatch( endpointFieldChange( value, endpointId, field ) ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Privacy);
